<template>
  <MountingPortal
    append
    mount-to="#portal-container--footer"
    name="onfigurator-texture-preview-modal"
  >
    <BaseModal
      v-model="localIsActive"
      class="configurator-texture-preview-modal"
    >
      <ConfiguratorTextureCanvasEnhancer
        :resolution="Resolution.WEB"
        include-background
        full-texture
        with-placeholders
      />
    </BaseModal>
  </MountingPortal>
</template>

<script>
import BaseModal from '../BaseModal';
import ConfiguratorTextureCanvasEnhancer from './ConfiguratorTextureCanvasEnhancer';
import ModalState from '../../mixins/ModalState';
import { Resolution } from '../../utils/MathUtils';

export default {
  name: 'ConfiguratorTexturePreviewModal',
  components: { ConfiguratorTextureCanvasEnhancer, BaseModal },
  mixins: [ModalState],
  model: {
    prop: 'isActive',
    event: 'change',
  },
  data() {
    return {
      Resolution,
    };
  },
  computed: {
    localIsActive: {
      get() {
        return this.isActive;
      },
      set(v) {
        this.$emit('change', v);
      },
    },
  },
};
</script>
